import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

// Ассети цього флоу поки лежать локально, у public. Коли їх заллють на S3,
// міняється тільки цей рядок на getImageFromS3('images/sms-feedback/26ua-mrlb')
// — і url фону в index.module.scss.
const IMAGES_PATH = '/images/sms-feedback/26ua-mrlb';

// Спільна «обгортка» всіх екранів опитувальника: фон і лого зверху.
// Лого просто лежить на фоні, окремої плашки тут немає.
const Layout = ({ children, className, contentClassName }) => (
  <div
    className={classNames(styles.container, className)}
    style={{ backgroundImage: `url("${IMAGES_PATH}/bg.png")` }}
  >
    <div className={styles.header}>
      <img src={`${IMAGES_PATH}/header.svg`} alt="Marlboro" />
    </div>
    <div className={classNames(styles.content, contentClassName)}>
      {children}
    </div>
  </div>
);

export { IMAGES_PATH };
export default Layout;
